import { render } from "./page-mobile.vue?vue&type=template&id=02bb6862"
import script from "./page-mobile.js?vue&type=script&lang=js"
export * from "./page-mobile.js?vue&type=script&lang=js"

import "./page-mobile.vue?vue&type=style&index=0&id=02bb6862&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__